document.addEventListener("DOMContentLoaded", () => {
  async function formNutricionistas(elements, el) {
    var isClient = await isCustomer();
    if (isClient == true) {
      var params = await getParams();
      var ShopName = params[0];
      var customerID = params[2];
      let iFullName = $(elements["nutricionista-full_name"]).val();
      let iEmail = $(elements["nutricionista-email"]).val();
      let iPhone = $(elements["nutricionista-phone"]).val();
      let iNotes = $(elements["nutricionista-notes"]).val();
      let iNutrition_area = $(elements["nutricionista-nutrition_area"]).val();
      let iHas_patients = $(elements["nutricionista-has_patients"]).val();
      let iRegion = $(elements["nutricionista-region"]).val();
      let iTerms = $(elements["nutricionista-terms"]).val();
      let inputRequired = $(el).attr("required");
      $(".c-button__text").empty().append("Enviando..");
      $.ajax({
        type: "POST",
        url: "https://middlewaref.allnutrition.cl/api/nutritionist/application",
        headers: {
          Authorization: "Token e9f079b492c321e3d1f01688485169e51b7c0c2c",
        },
        data: {
          store: ShopName,
          shopify_id: customerID,
          full_name: iFullName,
          email: iEmail,
          phone: iPhone,
          notes: iNotes,
          nutrition_area: iNutrition_area,
          has_patients: iHas_patients,
          allow_data: iTerms,
          region: iRegion,
        },
        success: function (response) {
          $(el).find(".form-status-success").removeClass("d-none");
          $(el).find(".form-status-error").addClass("d-none");
          $(".c-button__text").empty().append("Enviar");
          $(elements["nutricionista-full_name"]).val("");
          $(elements["nutricionista-email"]).val("");
          $(elements["nutricionista-phone"]).val("");
          $(elements["nutricionista-notes"]).val("");
          $(elements["nutricionista-nutrition_area"]).val("");
          $(elements["nutricionista-has_patients"]).val(false);
          $(elements["nutricionista-region"]).val("");
          $(elements["nutricionista-terms"]).prop("checked", false);
          goToStep(4);
        },
        error: function (e, t) {
          $(el).find(".form-status-success").addClass("d-none");
          $(el).find(".form-status-error").removeClass("d-none");
          $(".c-button__tex").empty().append("Enviar");
        },
      });
    } else {
      $(el).find(".form-status-login").removeClass("d-none");
    }
  }

  $("#form-nutricionistas").on("submit", function (event) {
    event.preventDefault();
    var el = this;
    var elements = this.elements;
    formNutricionistas(elements, el);
  });
});
